import React, { Component, useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { getDataFromAPI } from "../../../HandleAPICalls/actions";
import { setLoading } from "../../OrderComp/OrdersList/actions";
import { Navigate, useParams } from "react-router-dom";
import LoadingSpinner from "../../Loading/component";
import dayjs from "dayjs";
import { v4 as uuidv4 } from "uuid";
import Tesseract from "tesseract.js";
import { createWorker } from "tesseract.js";
import { useNavigate, useLocation } from "react-router-dom";
import _ from "lodash";
import ScreensaversComp from "./component";
import DaalchiniPointsComp from "./component";

import {  toast } from "react-toastify";
const DaalchiniPointsListContainer = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
 
 const [loading, setLoading] = useState(true);
  const [daalchinipointMobile, setDaalchinipointMobile] = useState("");
  const [daalchinipointAmount, setDaalchinipointAmount] = useState("");
 


  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      daalchiniAddPointApi();
    }
  };

  const handleDaalchiniPointMobile = (e) => {
    const value = e.target.value.replace(/\D/g, ""); 
    if (value.length <= 10) {
      setDaalchinipointMobile(value);
    }
  };
  
  const handleDaalchiniPointAmount = (e) => {
    let value = e.target.value.replace(/\D/g, ""); 
    if (value.length <= 5) {
      if (/^[1-9]\d{0,4}$/.test(value) || value === "") {
        setDaalchinipointAmount(value);
      }
    }
  };
  

const daalchiniAddPointApi = () => {
   
    const payload = {
      data:{
        amount: daalchinipointAmount,
    
        phoneNumber:  parseInt(daalchinipointMobile),
      },
     
      paymentGatewayId:"9"
      
    };

    props.getDataFromAPI(
      `/dashboard/api/v4/recharge`,
      "POST",
      payload,
      (response) => {
        console.log("API response:", response);

        setDaalchinipointAmount("");
        setDaalchinipointMobile("");
     
        toastr.success("Recharge Successfully");
        navigate("/");
      },
      (err) => {
        console.log("err add recharge api ", err.message);
        toastr.error(`${err.message}`, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        });
      }
    );
  };



  return (
    <DaalchiniPointsComp
    loading={loading}
      daalchiniAddPointApi={daalchiniAddPointApi}
      daalchinipointAmount={daalchinipointAmount}
      daalchinipointMobile={daalchinipointMobile}
      handleDaalchiniPointMobile={handleDaalchiniPointMobile}
      handleDaalchiniPointAmount={handleDaalchiniPointAmount}
      handleKeyPress={handleKeyPress}
    />
  );
};
function mapStateToProps({ props }) {
  return {
    props,
  };
}

export default connect(mapStateToProps, {
  getDataFromAPI,
  setLoading
})(DaalchiniPointsListContainer);
